export default __webpack_public_path__ + "static/media/heroImg.67817bce.png";